<div class="login">
  <div class="form">
    <img src="../../../assets/icons/fogo-e-peixe.png" class="logo" />
    <form [formGroup]="form">
      <p>
        <mat-form-field appearance="outline">
          <input matInput placeholder="E-mail" formControlName="email" autocomplete="username" />
          <mat-hint class="warn" *ngIf="form.controls['email'].errors && form.controls['email'].touched">
            E-mail inválido!
          </mat-hint>
        </mat-form-field>
      </p>

      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Senha"
          formControlName="password"
          [type]="isVisibility ? 'text' : 'password'"
          name="password"
          autocomplete="current-password"
        />
        <mat-icon matSuffix (click)="changeIsVisibility()" style="cursor: pointer">{{
          !isVisibility ? 'visibility' : 'visibility_off'
        }}</mat-icon>
        <mat-hint class="warn" *ngIf="form.controls['password'].errors && form.controls['password'].touched">
          Senha Obrigatória!
        </mat-hint>
      </mat-form-field>

      <div class="links">
        <mat-checkbox class="example-margin" formControlName="saveData">Salvar dados</mat-checkbox>
        <a style="cursor: pointer" (click)="requestPassword()"> esqueci a senha </a>
      </div>
      <br />

      <p>
        <button class="btn-primary" mat-raised-button color="primary" (click)="login()" [disabled]="form.invalid">
          LOGIN
        </button>
      </p>
    </form>
    <button class="btn-secundary" mat-raised-button color="primary" (click)="openRegisterModal(registerDialog)">CADASTRAR</button>
    <ng-template #registerDialog>
      <h2 mat-dialog-title style="text-align: center;">Selecione o tipo de cadastro</h2>
      <mat-dialog-content style="display: flex; flex-direction: column; gap: 15px; margin-top: 10px;">
        <button mat-raised-button color="primary" [routerLink]="['/cadastrar']" mat-dialog-close>Membro</button>
        <button mat-raised-button color="primary" [routerLink]="['/novo-convertido']" mat-dialog-close>Novo Convertido</button>
      </mat-dialog-content>
      <mat-dialog-actions align="center" style="margin-top: 10px;">
        <button mat-button mat-dialog-close>Cancelar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</div>
